// API Configuration
export const API_BASE_URL =
  import.meta.env.VITE_API_BASE_URL || 'https://bot-stage.rocketproxy7.shop/api/v1' 
  // 'http://localhost:3000/api/v1';

// Default Language
export const DEFAULT_LANGUAGE =
  import.meta.env.VITE_DEFAULT_LANGUAGE || 'ar';

// Environment
export const ENV = import.meta.env.VITE_ENV || 'development';

// Telegram Support (رابط حساب الدعم على تيليجرام)
export const TELEGRAM_SUPPORT_URL =
  import.meta.env.VITE_TELEGRAM_SUPPORT_URL || 'https://t.me/cyberofficialc';

// API Endpoints
export const API_ENDPOINTS = {
  AUTH: {
    LOGIN: '/auth/login',
    REGISTER: '/auth/register',
    TELEGRAM_LOGIN: '/auth/telegram-login',
  },
  USERS: {
    ME: '/users/me',
    BALANCE: '/users/me/balance',
    TRANSACTIONS: '/users/me/transactions',
  },
  ADMIN: {
    USERS: '/admin/users',
    PRODUCTS: '/admin/products',
    CATEGORIES: '/admin/categories',
  },
  CATALOG: {
    CATEGORIES: '/catalog/categories',
    PRODUCTS: '/catalog/categories/:categoryId/products',
  },
  RECHARGE: {
    PAYEER: '/recharge/payeer',
    CRYPTO: '/recharge/crypto',
    SYRIATEL: '/recharge/syriatel',
    SHAM_CASH: '/recharge/sham-cash',
  },
} as const;

